import React from "react";
import style from "./NewsDigest.module.scss";
import { Img } from "../ImgV2/Img";
import like from "./assets/like.svg";
import share from "./assets/share.svg";
import { SwitchBar, SwitchBarPosition } from "../components/SwitchBar/SwitchBar";
import { DateUtil } from "imagica-corekit/dist/base/util/DateUtil";
export function NewsDigest(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: style["news-feed"]
  }, /*#__PURE__*/React.createElement(SwitchBar, {
    sliderCount: props.news_feed.length,
    position: SwitchBarPosition.bottom
  }, props.news_feed.map(function (item, index) {
    return /*#__PURE__*/React.createElement(NewsItemView, {
      key: index,
      newsModel: item.news_article
    });
  })));
}
export function NewsItemView(props) {
  var _props$newsModel$sour, _props$newsModel$sour2;
  return /*#__PURE__*/React.createElement("div", {
    className: style["news-card"]
  }, /*#__PURE__*/React.createElement("div", {
    className: style["imgBox"]
  }, /*#__PURE__*/React.createElement(Img, {
    className: "newsDigestImg",
    imgKey: props.newsModel.news_image
  })), /*#__PURE__*/React.createElement("div", {
    className: style["news-content"]
  }, /*#__PURE__*/React.createElement("div", {
    className: style.likeBox
  }, /*#__PURE__*/React.createElement("img", {
    src: like
  })), /*#__PURE__*/React.createElement("div", {
    className: style.shareBox
  }, /*#__PURE__*/React.createElement("img", {
    src: share
  })), /*#__PURE__*/React.createElement("p", {
    className: style.category
  }, props.newsModel.news_category), /*#__PURE__*/React.createElement("p", {
    className: style.title
  }, props.newsModel.news_title), /*#__PURE__*/React.createElement("p", {
    className: style.restaurantType
  }, props.newsModel.author_name, " \u2022 ", props.newsModel.read_time)), /*#__PURE__*/React.createElement("div", {
    className: style.buttonBox
  }, /*#__PURE__*/React.createElement("p", {
    className: style.preview
  }, props.newsModel.news_preview), /*#__PURE__*/React.createElement("div", {
    className: style.sourceBox
  }, /*#__PURE__*/React.createElement("img", {
    src: (_props$newsModel$sour = props.newsModel.source) === null || _props$newsModel$sour === void 0 ? void 0 : _props$newsModel$sour.source_icon
  }), /*#__PURE__*/React.createElement("p", {
    className: style.source
  }, (_props$newsModel$sour2 = props.newsModel.source) === null || _props$newsModel$sour2 === void 0 ? void 0 : _props$newsModel$sour2.source_text, " \u2022 ", DateUtil.calculateTimeAgo(props.newsModel.time_posted)))));
}